import { generateNextSectionName } from "./projectNaming";

// Navigation ve Section işlemleri için state management
export const DefaultNavigationState = {
  // Mevcut section ID (varsa)
  section: {
    title: "Section 1",
    content: "",
    type: "",
    style: "",
    rootImageUrl: "",
    resultImageUrl: "",
    thumbnailUrl: "",
    designs: [],
    productIds: [],
  },

  // Yeni section oluşturuluyor mu?
  isCreatingNewSection: false,

  // Project ID (yeni section için gerekli)
  project: {
    name: "New Project",
    details: "",
    mobilePhone: "",
    address: {
      line1: "",
      line2: "",
    },
    rootImageUrl: "",
    resultImageUrl: "",
    thumbnailUrl: "",
    type: "",
    style: "",
    sections: [],
  },

  // İşlem akışı: 'existing' | 'new'
  flowType: "existing", // 'existing' veya 'new'

  // Geçici veriler
  image: "",
  roomType: undefined,
  selectedProducts: [],
  originalImage: "",

  // products sayfasına giriş: 'catalog' | 'design'
  productsEntry: null,

  // Collections → Go to Design sonrası geri dönüş yolu
  catalogReturnPath: null,

  // Collections → Go to Design ile başlatılan yeni proje akışı
  fromCatalogDesign: false,
};

// Navigation flow maps
const flowMap = {
  existing: {
    "*": "/section-details",
    camera: "/photograph",
    photograph: "/section-details",
    products: "/section-details",
    "room-type": "/section-details",
  },
  new: {
    "*": "/camera",
    camera: "/photograph",
    photograph: "/products",
    products: "/section-details",
  },
};

const backMap = {
  existing: {
    photograph: "/section-details",
    products: "/section-details",
    "room-type": "/section-details",
  },
  new: {
    camera: "/projects",
    photograph: "/camera",
    products: "/photograph",
    "section-details": "/products",
  },
};

export const NavigationState = { ...DefaultNavigationState };

// State'i güncelle
export const updateNavigationState = (updates) => {
  // Native JavaScript ile deep merge
  const deepMerge = (target, source) => {
    for (const key in source) {
      if (
        source[key] &&
        typeof source[key] === "object" &&
        !Array.isArray(source[key])
      ) {
        if (!target[key]) target[key] = {};
        deepMerge(target[key], source[key]);
      } else {
        target[key] = source[key];
      }
    }
    return target;
  };

  deepMerge(NavigationState, updates);
};

// State'i temizle
export const clearNavigationState = () => {
  Object.assign(NavigationState, DefaultNavigationState);
};

export const setContextSection = (section, replaceSection = undefined) => {
  NavigationState.section = section;
  const index = NavigationState.project.sections.findIndex((s) =>
    replaceSection ? replaceSection == s : s.id === section.id
  );
  if (index !== -1) {
    NavigationState.project.sections[index] = section;
  } else {
    NavigationState.project.sections.push(section);
  }
};

// Yeni section akışı başlat
export const startNewSectionFlow = (project, section) => {
  clearNavigationState();
  if (project) NavigationState.project = project;
  else project = { ...DefaultNavigationState.project };

  if (!section) {
    section = {
      ...DefaultNavigationState.section,
      title: generateNextSectionName(project.sections || []),
    };
  }

  NavigationState.section = section;
  NavigationState.project = project;
  setContextSection(section);

  NavigationState.flowType = "new";
  NavigationState.sectionMode = "update-section";
};

// Mevcut section akışı başlat
export const startExistingSectionFlow = (project, section) => {
  clearNavigationState();
  NavigationState.project = project;
  NavigationState.section = section;
  NavigationState.flowType = "existing";
};

// Sonraki sayfayı belirle
export const getNextPage = (currentPage = "*", data = {}) => {
  // Geçici verileri güncelle (sadece yeni veri varsa)
  updateNavigationState(data);
  // Akış tipine göre sonraki sayfayı döndür
  const nextPage = flowMap[NavigationState.flowType]?.[currentPage];

  if (!nextPage) {
    console.warn(
      `No next page found for flow: ${NavigationState.flowType}, page: ${currentPage}`
    );
    return "/";
  }

  if (nextPage === "/products" && NavigationState.flowType === "new") {
    NavigationState.productsEntry = "design";
  }

  return nextPage;
};

export const buildCatalogProductsPath = (category, subCategory) => {
  const params = new URLSearchParams();
  if (category) {
    params.set("category", category);
  }
  if (subCategory) {
    params.set("subCategory", subCategory);
  }
  const query = params.toString();
  return query ? `/products?${query}` : "/products";
};

export const navigateToCatalogReturn = (navigate) => {
  const returnPath = NavigationState.catalogReturnPath;
  if (!returnPath) {
    return false;
  }

  NavigationState.catalogReturnPath = null;
  navigate(returnPath);
  return true;
};

// Geri dönüş sayfasını belirle
export const getBackPage = (currentPage) => {
  const backPage = backMap[NavigationState.flowType]?.[currentPage];

  if (!backPage) {
    console.warn(
      `No back page found for flow: ${NavigationState.flowType}, page: ${currentPage}`
    );
    return "/";
  }
  return backPage;
};

// Room types for the project
export const roomTypes = [
  { id: 1, name: "Balcony & Terrace", image: "/assets/product-02.png" },
  { id: 2, name: "Garden", image: "/assets/product-03.png" },
  { id: 3, name: "Cafe", image: "/assets/product-04.png" },
  { id: 4, name: "Pool", image: "/assets/product-05.png" },
  /*{ id: 5, name: "Gazebo", image: "/assets/product-07.png" },*/
  { id: 6, name: "Home", image: "/assets/image-thumb-1622812710-5680.jpg" },
  { id: 7, name: "Office", image: "/assets/image-thumb-1567499374-3484.jpg" },
  { id: 8, name: "Event", image: "/assets/image-thumb-1545207079-7219.jpg" },
  { id: 9, name: "Wedding", image: "/assets/image-thumb-1544088234-7313.jpg" },
  {
    id: 10,
    name: "Bar & Pub",
    image: "/assets/image-thumb-1693477363-1427.jpg",
  },
  {
    id: 11,
    name: "Restaurant",
    image: "/assets/image-thumb-1750429007-5791.jpg",
  },
  {
    id: 12,
    name: "Meeting Room",
    image: "/assets/image-thumb-1563355985-8671.jpg",
  },
  {
    id: 13,
    name: "Mall & Food Court",
    image: "/assets/image-thumb-1735136428-3878.jpg",
  },
  /*{ id: 6, name: "Rattan", image: "/assets/product-08.png" },
  { id: 7, name: "Piknik", image: "/assets/product-09.png" },
  { id: 8, name: "Restaurant", image: "/assets/product-10.png" },*/
];

export {
  catalogCollections,
  categoriesMap,
  getCollectionConfig,
  getSubCategoriesForCollection,
  getSubCategoryConfig,
  getDefaultCollectionSlug,
  getDefaultSubCategorySlug,
  normalizeCatalogSelection,
  getCollectionCrmValue,
  getSubCategoryCrmValue,
} from "./siestaCatalog";
